export const type = {
  PROJECTS: 'PROJECTS',
  SYNC: 'SYNC',
}
